<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: lau
 * @Date: 2023-04-19 09:31:20
 * @LastEditors: lau
 * @LastEditTime: 2023-04-20 15:53:50
-->
<!-- 获取账号下所有授权停车场的编码接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {"carNo":"粤Z6751港","carCodeColor":3,"origin":"1","grantUserId":"2138","couponCode":"BWY291O4S6627T7"},
            responseCode: {
                "count": 0,
                "message": "业务成功", "resultCode": 0, "status": 1
                },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台根据券编码发券",
                t_url: this.commonUrls.test+"sendCouponByCouponCode",
                p_url: this.commonUrls.prod+"sendCouponByCouponCode",
                precondition: "无",
                fitSystem: "VEMS传统停车场, 云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                    { info1: 'couponCode', info2: '是', info3: 'String', info4: '券编码' },
                            { info1: 'carNo', info2: '否', info3: 'String', info4: '车牌号码' },
                            { info1: 'parkingCode', info2: '否', info3: 'String', info4: '停车记录编号' },
                            { info1: 'carCodeColor', info2: '否', info3: 'Integer', info4: '车牌颜色（1蓝色，2黄色，3白色，4黑色，5绿色），默认1蓝色，ps:(如果车牌号码已经自带颜色了，carCodeColor失效)' },
                            { info1: 'origin', info2: '否', info3: 'Integer', info4: '0未定义，1动态领券' },
                            { info1: 'grantUserId', info2: '否', info3: 'Long', info4: '发券人id' },

                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                      
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/deprecated/tradercoupon/sendCouponByCouponCode.vue